import Loader from "@/elements/components/shared/loader";
import LegalSheet from "@/elements/components/sheets/legal-sheet";
import { auth } from "@/elements/components/utils/convex-api";
import { convexQuery } from "@convex-dev/react-query";
import { useQuery } from "@tanstack/react-query";
import { Slot, Redirect } from "expo-router";
import React from "react";

function OnboardingLayout() {
  const { data: isAuthenticated, isSuccess } = useQuery(
    convexQuery(auth.isAuthenticated, {})
  );

  if (!isSuccess) {
    return <Loader />;
  }

  if (!isAuthenticated) {
    return <Redirect href={"/(auth)/sign-in-options"} />;
  }

  return (
    <>
      <Slot />
      <LegalSheet />
    </>
  );
}

export default OnboardingLayout;
